export class AccountCompanyAddress {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  postCode: string;
  country: string;
  county: string;

  regAddressLine1: string;
  regAddressLine2: string;
  regAddressLine3: string;
  regAddressLine4: string;
  regPostCode: string;
  regCountry: string;
  regCounty: string;

  telephone: string;
  mobile: string;
  fax: string;
  email: string;

  getDeepCopy(): AccountCompanyAddress {
    const copy = new AccountCompanyAddress();
    copy.addressLine1 = this.addressLine1;
    copy.addressLine2 = this.addressLine2;
    copy.addressLine3 = this.addressLine3;
    copy.addressLine4 = this.addressLine4;
    copy.postCode = this.postCode;
    copy.country = this.country;
    copy.county = this.county;

    copy.regAddressLine1 = this.regAddressLine1;
    copy.regAddressLine2 = this.regAddressLine2;
    copy.regAddressLine3 = this.regAddressLine3;
    copy.regAddressLine4 = this.regAddressLine4;
    copy.regPostCode = this.regPostCode;
    copy.regCountry = this.regCountry;
    copy.regCounty = this.regCounty;

    copy.telephone = this.telephone;
    copy.mobile = this.mobile;
    copy.fax = this.fax;

    copy.email = this.email;

    return copy;
  }
}
